// import { Platform } from "react-native";
// import { createBrowserHistory } from "history";
import { createStore, applyMiddleware, compose } from "redux";
import { createLogger } from "redux-logger";
import createRootReducer from "./reducers/allReducers";
import { routerMiddleware } from "connected-react-router";
import { persistStore, persistReducer } from "redux-persist";
// import AsyncStorage from '@react-native-async-storage/async-storage';
import storage from "redux-persist/lib/storage";
// import { REACTPATH } from "../constants/config";

// export const history = createBrowserHistory({ basename: "." });

const initialState = {
  // router: null,
  // videos: null,
};

const persistConfig = {
  key: "petStory",
  storage,
  blacklist: ["router"],
};

const configureStore = (sagaMiddleware, storeHistory) => {
  //const sagaMiddleware = createSagaMiddleware()
  const reducers = createRootReducer(storeHistory);
  // MyLog(reducers.router);
  const store = createStore(
    persistReducer(persistConfig, reducers), // root reducer with router state
    initialState,
    compose(
      applyMiddleware(
        routerMiddleware(storeHistory), // for dispatching history actions
        sagaMiddleware,
        createLogger({ collapsed: true, diff: true, duration: true })
      )
      // window.__REDUX_DEVTOOLS_EXTENSION__ &&
      //     window.__REDUX_DEVTOOLS_EXTENSION__()
      //DevTools.instrument()
    )
  );
  //sagaMiddleware.run(rootSaga)
  const persistor = persistStore(store);

  return { store, persistor };
};

export default configureStore;
